<template>
	<div v-if="cart.cpu" class="accessories-store container-fluid">
		<rule-modal
			@close="setRules([])"
		/>
		<div class="row bg-white">
			<div class="static-pages">
				<div class="static-pages-content p-t p-b-xl">
					<div class="container">
						<div class="row">
							<div class="col-xs-12">
								<subtotal-row
									class="sub-total-row--top"
									:action="() => gotoCart('Top')"
								/>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<h1 class="title">Any Accessories?</h1>
							</div>
						</div>
						<div class="row">
							<div
								v-if="storage.length && selectedStorage"
								class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
							>
								<storage-card
									:selected-storage="selectedStorage"
									:storage="storage"
								/>
							</div>
							<template v-for="(accessory, type) in accessories">
								<div
									v-for="item in accessory"
									:key="item.id"
									class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
								>
									<template v-if="!+item.is_hidden">
										<accessory-card :accessory="item" :type="type" />
									</template>
								</div>
							</template>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<div class="sub-total-row">
									<sub-total :action="() => gotoCart('Bottom')">
										Continue To Cart
									</sub-total>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<loading v-else />
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { heapAnalytics } from "@u/mixins.js";
import HelpersMixin from "../helpers-mixin";
import _isEmpty from "lodash/isEmpty";
import AccessoryCard from "./accessory-card";
import StorageCard from "./storage-card";
import SubtotalRow from "./sub-total-row/";
import SubTotal from "./sub-total-row/sub-total";
import RuleModal from "./rule-modal";
import { gtmMap, gtmTrigger, gtmTrack } from "@/util/gtm";

export default {
	name: "AccessoriesStore",
	components: {
		AccessoryCard,
		StorageCard,
		SubtotalRow,
		SubTotal,
		RuleModal
	},
	mixins: [
		heapAnalytics,
		HelpersMixin
	],
	computed: {
		...mapGetters({
			storage: "StarterPc/getExternalStorage",
			trackStarterType: "StarterPc/getTrackType",
			userCurrency: "userCurrency"
		}),
		...mapState({
			accessories: state => state.StarterPc.accessories,
			rules: state => state.StarterPc.rules,
			selectedStorage: state => state.StarterPc.selectedStorage,
			storage: state => state.StarterPc.externalStorage
		})
	},
	watch: {
		rules(list) {
			if (list.length) {
				const rulesText = [];

				list.forEach(item => {
					if (!["enable", "disabled"].includes(item.ruleType)) {
						rulesText.push(item.msg);
					}
				});

				if (rulesText.length) {
					this.$modal.show("ruleModal", {
						title: "Error",
						content: rulesText.join("<br>")
					});
				}
			}
		}
	},
	created() {
		if (_isEmpty(this.cart)) {
			this.$store.dispatch("StarterPc/getData", {
				which: this.$route.meta.group,
				route: this.which
			});
		}
	},
	beforeMount() {
		window.addEventListener("beforeunload", this.checkNavigation);
	},
	beforeDestroy() {
		window.removeEventListener("beforeunload", this.checkNavigation);
	},
	beforeRouteLeave(to, from, next) {
		if (to.name.includes("-cart")) {
			gtmTrack.cartTotal(this.$store.state.StarterPc.total);

			if (this.gtmPrebuildVariables && this.gtmPrebuildVariables.pcSKU) {
				gtmTrack.cartPrebuild(this.gtmPrebuildVariables);
			}
		}
		next();
	},
	methods: {
		...mapActions({
			setRules: "StarterPc/setRules"
		}),
		gotoCart(pageLocation) {
			this.trackAll(`Client: Click ${this.trackStarterType} ContinueToCart`, {
				page_location: pageLocation,
				page: "Accessory Page"
			});
			gtmTrigger.addToCart(this.getCartAccesoriesGTM(), pageLocation, this.userCurrency);
			this.$router.push({ name: `${this.which}-cart` });
		},
		getCartAccesoriesGTM() {
			const gtmAccesoriesCart = [];
			const types = Object.keys(this.accessories);
			types.forEach(type => {
				if (_isEmpty(this.accessories[type])) {
					return;
				}

				if (!Array.isArray(this.cart[type])) {
					if (this.cart[type].id) {
						const gtmAccesory = gtmMap.starterSeriesAccessoryToProduct(this.cart[type], this.which);
						gtmAccesoriesCart.push(gtmAccesory);
					}
					return;
				}

				this.cart[type].forEach(accessory => {
					if (!accessory.id) {
						return;
					}

					if (Array.isArray(this.accessories[type])) {
						const isPrebuildAccessory = this.accessories[type]
							.some(prebuildAccessory => prebuildAccessory.id == accessory.products_id);

						if (isPrebuildAccessory) {
							const gtmAccesory = gtmMap.starterSeriesAccessoryToProduct(accessory, this.which);
							gtmAccesoriesCart.push(gtmAccesory);
						}
					}
				});
			});

			if (this.selectedStorage.id) {
				const addStorageGTM = (storage) => {
					const gtmStorage = gtmMap.starterSeriesAccessoryToProduct(storage, this.which, "capacity");
					gtmAccesoriesCart.push(gtmStorage);
				};

				this.cart.storage.forEach(cartStorage => {
					if (Object.keys(cartStorage.hdd || {}).includes(this.selectedStorage.id)) {
						addStorageGTM(cartStorage.hdd[this.selectedStorage.id]);
					}
					if (Object.keys(cartStorage.ssd || {}).includes(this.selectedStorage.id)) {
						addStorageGTM(cartStorage.ssd[this.selectedStorage.id]);
					}
				});
			}
			return gtmAccesoriesCart;
		},
		checkNavigation() {
			sessionStorage.setItem("last-prebuild-in-checkout-flow", JSON.stringify({
				path: this.$route.path,
				group: this.$route.meta.group
			}));
		}
	}
};
</script>

<style lang="scss" scoped>
.accessories-store {
    .title {
        color: #444259;
        font-size: 36px;
        line-height: 43px;
        text-align: center;
        text-transform: uppercase;
        margin-top: 40px;
        margin-bottom: 45px;

        @media (max-width: 768px) {
            text-align: left;
            margin-right: 20px;
            margin-top: 20px;
            margin-bottom: 25px;
        }
    }

    .sub-total-row {
        display: flex;
        border-top: 1px solid #dadde0;

        .sub-total {
            margin-left: auto;
            padding-top: 50px;

            @media (max-width: 768px) {
                padding-top: 0;
            }
        }
    }
}
</style>
